export class LevelIdRequset{
    levelId?:number;
    
    constructor(levelId:number){
    this.levelId = levelId;
    }
} 
